// 获取用户信息 - 肉牛良繁
export const beefUserInfo = type => {
  const UserInformation_Beef = JSON.parse(localStorage.getItem('UserInformation_Beef'));
  if (UserInformation_Beef) {
    if (type === 'all') return UserInformation_Beef;
    else return UserInformation_Beef.userAppInfo ? UserInformation_Beef.userAppInfo[0] : '';
  } else return '';
};

// 获取用户信息 - 种畜禽
export const LBUserInfo = type => {
  const UserInformation_LB = JSON.parse(localStorage.getItem('UserInformation_LB'));
  if (UserInformation_LB) {
    if (type === 'all') return UserInformation_LB;
    else return UserInformation_LB.userAppInfo ? UserInformation_LB.userAppInfo[0] : '';
  } else return '';
};

// 获取用户信息 - 智慧养殖
export const ZHYZUserInfo = type => {
  const UserInformation_ZHYZ = JSON.parse(localStorage.getItem('UserInformation_ZHYZ'));
  if (UserInformation_ZHYZ) {
    if (type === 'all') return UserInformation_ZHYZ;
    else return UserInformation_ZHYZ.farmItems ? UserInformation_ZHYZ.farmItems[0] : '';
  } else return '';
};



// WEBPACK FOOTER //
// ./src/views/breedingcattle/common/index.js